export const NARRATIVE_SUPPORTED_VALUATION_TYPES = [
  'DCF',
  'USER_DEFINED',
  'ANALYSTS',
] as const;
export type NarrativeSupportedValuationType =
  (typeof NARRATIVE_SUPPORTED_VALUATION_TYPES)[number];

export const isSupportedValuationType = (
  type: string
): type is NarrativeSupportedValuationType => {
  return NARRATIVE_SUPPORTED_VALUATION_TYPES.includes(
    type as NarrativeSupportedValuationType
  );
};
